import { FolderClosed, Plus } from "lucide-react";

import { translations } from "utils/i18n";
import { useLanguage } from "context/languageContext";
import { Button } from "components/ui/button";
import { useProjectsContext } from "pages/ProjectsLayout";

/**
 * What shows in the content pane at the bare /projects route — the panel
 * (see ProjectsLayout) is the actual project list now, so this is just a
 * landing state: prompt to pick one, or create the first one.
 */
export default function ProjectsPage() {
  const { projects, openCreateProject } = useProjectsContext();
  const { language } = useLanguage();
  const tr = translations[language].home;

  if (projects.length === 0) {
    return (
      <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center gap-3 p-8 text-center">
        <FolderClosed className="size-8 text-muted-foreground" aria-hidden="true" />
        <div className="grid gap-1">
          <p className="text-sm font-medium text-foreground">{tr.emptyTitle}</p>
          <p className="text-sm text-muted-foreground">{tr.emptyDescription}</p>
        </div>
        <Button onClick={openCreateProject}>
          <Plus className="size-4" />
          {tr.newProject}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center gap-1 p-8 text-center">
      <p className="text-sm font-medium text-foreground">{tr.selectTitle}</p>
      <p className="text-sm text-muted-foreground">{tr.selectDescription}</p>
    </div>
  );
}
